import { baseArkhaleAPI } from './base-api'
import { Pagination } from '../../shared/models/others/pagination'
import { NotificationRecipientQuery } from './query-type'
import { NotificationRecipient } from '../../shared/models/notification.model'
import { NotificationRecipientID } from '../../shared/models/id/notification-recipient-i-d'

const notificationRecipientApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => {
    return {
      getNotificationRecipients: build.query<
        Pagination<NotificationRecipient>,
        NotificationRecipientQuery
      >({
        query: (args) => ({
          url: '/notifications/recipients',
          method: 'GET',
          params: {
            offset: args.offset,
            limit: args.limit,
            textSearch: args.textSearch,
            tenantID: args.tenantID,
          },
        }),
      }),
      getNotificationRecipient: build.query<
        NotificationRecipient,
        NotificationRecipientID
      >({
        query: (args) => ({
          url: 'notifications/recipients/' + args.id,
          method: 'GET',
        }),
      }),
      addNotificationRecipient: build.mutation<
        NotificationRecipient,
        NotificationRecipient
      >({
        query: (arg) => ({
          url: '/notifications/recipients',
          method: 'POST',
          body: arg,
        }),
      }),
    }
  },
})

export const {
  useAddNotificationRecipientMutation,
  useLazyGetNotificationRecipientsQuery,
  useLazyGetNotificationRecipientQuery,
} = notificationRecipientApi
